// Date utilities for production calendar
export const MONTHS_RU = [
  "Январь","Февраль","Март","Апрель","Май","Июнь",
  "Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"
];
export const WEEKDAYS_RU = ["Пн","Вт","Ср","Чт","Пт","Сб","Вс"];

export const ymKey = (year, month) => `${year}-${String(month + 1).padStart(2, "0")}`;
export const ddKey = (day) => String(day).padStart(2, "0");

export const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

// Returns weekday Mon=0..Sun=6
export const weekdayMon0 = (year, month, day) => {
  const js = new Date(year, month, day).getDay(); // Sun=0..Sat=6
  return (js + 6) % 7;
};

export const todayParts = () => {
  const d = new Date();
  return { year: d.getFullYear(), month: d.getMonth(), day: d.getDate() };
};

export const isSameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const formatDate = (d) =>
  `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
